import Cookie from '@/services/cookie';
import store from '@/apps/dashboard/store';

export default {
    async redirectIfNotAuthenticated(to, from, next) {
        if (to.query.af_access_token) {
            Cookie.setToken(to.query.af_access_token);
            window.location.href = '/user-dashboard';
            return;
        }

        const token = Cookie.getToken();
        const redirectToLogin = `/user-login?redirect=${window.location.pathname}`;

        if (!token) {
            window.location.href = redirectToLogin;
            return;
        }

        if (!store?.state?.user?.id) {
            await store.dispatch('me/getMe');
            if (!Cookie.getToken()) {
                window.location.href = redirectToLogin;
                return;
            }
        }

        await store.dispatch('site/getSeekerFields');

        next();
    },
};
